import classNames from "classnames";
import React from "react";

export type PaginationButtonProps = {
  children?: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};

export const PaginationButton = ({
  children,
  active,
  onClick,
  disabled,
}: PaginationButtonProps) => {
  const internalClassName = classNames("gpc__pagination-button", {
    active,
  });
  return (
    <button className={internalClassName} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default PaginationButton;
